import {ApiClientService, EntityApiService} from '@dofleini/security';
import {authentication} from '@/settings';
import {InFilter} from '@dofleini/query-builder';

class SpaceApiService extends EntityApiService {
    existIdentifier = (params) => {
      return ApiClientService.post(this.getPath('/exist-identifier'), params);
    };

    mySpaces = () => {
      return ApiClientService.get(this.getPath('/my-spaces'), {});
    }

    getServicesTemplatesGoal = (spaceId) => {
      return ApiClientService.post(this.getPath(`/${spaceId}/services-templates-goal`));
    }

    getServicesFromSpace = () => {
      return ApiClientService.post(this.getPath('/user-services'));
    }

    getClientFromSpace = (secureSpacePath) => {
      const filter = new InFilter({
        field: 'secureSpacePath',
        value: secureSpacePath,
      }).toQuery();
      return ApiClientService.post(this.getPath('/get-client'), {filters: filter});
    }
}

export default new SpaceApiService(`${authentication.path}/api/spaces`);
